/// <reference path="../../../Cognito.Web.Client/apps/spa/src/views/admin/utils/exoweb.d.ts" />
((typeof exports != 'undefined' ? exports : {}).exec = function (isInIframe) {
	Cognito.ready("publish", ["Cognito.Forms", "ExoWeb.dom"], function ($) {

		// Theme ID constant for custom styles (no theme applied)
		const CUSTOM_STYLES_THEME_ID = "-1";

		Cognito.Forms.model.fonts = [
			{ Name: "System Font", Family: "system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen,Ubuntu,Cantarell,sans-serif" },
			{ Name: "Architects Daughter", Family: "'Architects Daughter',cursive" },
			{ Name: "Arial", Family: "Arial,Helvetica,sans-serif" },
			{ Name: "Arvo", Family: "'Arvo', serif" },
			{ Name: "Berkshire Swash", Family: "'Berkshire Swash',cursive" },
			{ Name: "Comic Sans", Family: "'Comic Sans MS',cursive,sans-serif" },
			{ Name: "Courier", Family: "'Courier New',Courier,'Lucida Sans Typewriter','Lucida Typewriter',monospace" },
			{ Name: "Dancing Script", Family: "'Dancing Script',cursive" },
			{ Name: "Georgia", Family: "Georgia,serif" },
			{ Name: "Handlee", Family: "'Handlee', cursive" },
			{ Name: "Limelight", Family: "'Limelight',cursive" },
			{ Name: "Lobster", Family: "'Lobster',cursive" },
			{ Name: "Lora", Family: "'Lora',serif" },
			{ Name: "Montserrat", Family: "'Montserrat',sans-serif" },
			{ Name: "Neuton", Family: "'Neuton',serif" },
			{ Name: "Open Sans", Family: "'Open Sans',Helvetica,sans-serif" },
			{ Name: "Open Sans Condensed", Family: "'Open Sans Condensed',Helvetica,sans-serif" },
			{ Name: "Oswald", Family: "'Oswald',Helvetica,sans-serif" },
			{ Name: "Princess Sofia", Family: "'Princess Sofia',cursive" },
			{ Name: "Raleway", Family: "'Raleway',Helvetica,sans-serif" },
			{ Name: "Roboto Condensed", Family: "'Roboto Condensed',Helvetica,sans-serif" },
			{ Name: "Roboto Slab", Family: "'Roboto Slab',Helvetica,sans-serif" },
			{ Name: "Shadows Into Light", Family: "'Shadows Into Light Two',Helvetica,sans-serif" },
			{ Name: "Times New Roman", Family: "Times New Roman,Times,serif" },
			{ Name: "Trebuchet MS", Family: "Trebuchet MS,Helvetica,sans-serif" },
			{ Name: "Ubuntu", Family: "'Ubuntu',sans-serif" },
			{ Name: "Verdana", Family: "Verdana,Geneva,sans-serif" },
			{ Name: "Vollkorn", Family: "'Vollkorn',Helvetica,sans-serif" }
		];

		function computeColorLibrary() {
			var colorRegex = /Color$/;
			var theme = Cognito.Forms.model.theme;
			// gather all color properties
			var colorProps = theme.meta.type.get_properties()
				.map(function (p) { return p.get_name(); })
				.filter(function (p) { return colorRegex.test(p); });
			var styleProperties = theme.meta.type.get_properties().filter(function (p) {
				var meta = p.get_jstype().meta;
				return meta && meta.type.get_fullName() === "Cognito.Forms.ElementStyle";
			});

			Array.prototype.push.apply(colorProps, styleProperties.map(function (p) { return p.get_name() + ".Color"; }));
			Array.prototype.push.apply(colorProps, styleProperties.map(function (p) { return p.get_name() + ".BackgroundColor"; }));

			var colorLibrary = theme.get_colorLibrary();
			var colors = colorProps
				.map(function (p) { return ExoWeb.evalPath(theme, p); })
				.filter(function (color) { return !!color; })
				.distinct();
			// clear and repopulate the array to ensure color picker components react to changes
			colorLibrary.splice(0, colorLibrary.length);
			Array.prototype.push.apply(colorLibrary, colors);
		}

		$extend("Cognito.Forms.ElementStyle", function (style) {
			style.meta.addRule({
				execute: function (sender, args) {
					computeColorLibrary();
				},
				onChangeOf: ["Color", "BackgroundColor"]
			});
		});

		$extend("Cognito.Forms.ThemeSettings", function (theme) {
			theme.$HeaderAlignment.allowedValues("Cognito.Forms.Alignment.All");
			theme.$HeaderLayout.allowedValues("Cognito.Forms.HeaderLayout.All");

			theme.meta.addProperty({ name: "hasChanges", type: Boolean, defaultValue: false }).calculated({
				calculate: function () {
					return Cognito.Forms.model.persistedThemeData && this.get_hasChanges();
				}
			}).addChanged(function (sender, args) {
				Cognito.Messaging.trigger("toggleSaveButtonIsDirty", { origin: Cognito.config.baseUrl, data: args.newValue });
			});

			theme.meta.addProperty({ name: "useDefaultTheme", type: Boolean, defaultValue: false });

			theme.meta.addProperty({ name: "formMaxWidth", type: Number, format: "D" }).calculated({
				calculate: function () {
					$('.legacy-beta-forms-container').css({ 'max-width': this.get_FormMaxWidth() || Cognito.Forms.model.defaultFormMaxWidth });
					return this.get_FormMaxWidth() || Cognito.Forms.model.defaultFormMaxWidth;
				}
			}).addChanged(
				function (sender, args) {
					if (!args.calculated) {
						$('.legacy-beta-forms-container').css({ 'max-width': args.newValue });
						sender.set_FormMaxWidth(args.newValue);
					}
				}
			);

			theme.meta.addProperty({ name: "inputBorderColor", type: String }).calculated({
				calculate: function (sender, args) {
					if (sender.get_InputBorderColor()) {
						return sender.get_InputBorderColor();
					}
					return "rgba(204, 204, 204, 1)";
				}
			}).addChanged(
				function (sender, args) {
					if (!args.calculated) {
						sender.set_InputBorderColor(args.newValue);
					}
				}
			);

			theme.meta.addProperty({ name: "colorLibrary", type: Array }).defaultValue([]);
			theme.meta.addRule({
				execute: function (sender, args) {
					computeColorLibrary();
				},
				onChangeOf: [
					"FormBackgroundColor",
					"HighlightColor",
					"InputBorderColor",
					"HeaderBackgroundColor",
					"PageBackgroundColor"
				]
			});


			// The Logo and PageBackgroundImage objects don't seem to trigger their propertyChanged event handlers (see Cognito.Forms.initTheme)
			theme.meta.addRule({
				execute: function (sender, args) {
					// Bug 15092: Removing logo image from form does not reset header layout from 'Logo Only'
					// Bug 19013: Some forms have no top margin
					// Set to default form's header so it displays properly and so the dropdown option is selected when a logo is uploaded again.
					if (!sender.get_Logo())
						sender.set_HeaderLayout(Cognito.Forms.HeaderLayout.get_All()[0])

					if (args.oldValue !== null) {
						Cognito.Forms.model.theme.set_hasChanges(true);
						updateStyles();
					}
				},
				onChangeOf: "Logo{Url}, PageBackgroundImage{Url}"
			});

			theme.meta.addRule({
				execute: function (sender, args) {
					document.getElementById('c-forms-publish-save').setAttribute('data-dirty', args.newValue);
				},
				onChangeOf: ["hasChanges"]
			});
		});

		// View model
		var publishSettingsType = context.model.meta.addType("Cognito.PublishSettings");
		publishSettingsType.addProperty({ name: "formId", type: String });
		publishSettingsType.addProperty({ name: "formUrl", type: String });
		publishSettingsType.addProperty({ name: "publicKey", type: String });
		publishSettingsType.addProperty({ name: "seamlessCode", type: String });
		publishSettingsType.addProperty({ name: "framedCode", type: String });
		publishSettingsType.addProperty({ name: "ampedCode", type: String });
		publishSettingsType.addProperty({ name: "embedMode", type: String });
		publishSettingsType.addProperty({ name: "formHeight", type: Number })
			.addChanged(function formHeight$changed(sender, args) {
				if (!args.calculated && args.newValue) {
					var replacement = "height=\"" + (Math.max(300, args.newValue + 50)) + "\"";

					if (sender.get_framedCode())
						sender.set_framedCode(sender.get_framedCode().replace(/height=\"\d+?\"/gi, replacement));

					if (sender.get_ampedCode())
						sender.set_ampedCode(sender.get_ampedCode().replace(/height=\"\d+?\"/gi, replacement));
				}
			});
		publishSettingsType.addProperty({ name: "embedCode", type: String })
			.calculated({
				calculate: function embedCode$calculation(sender) {
					return ExoWeb.getValue(sender, sender.get_embedMode());
				},
				onChangeOf: ["embedMode", "formHeight"]
			});

		function clearStyleRules(sheet) {
			var rules = sheet.rules || sheet.cssRules;

			if (rules.length === 0) return;

			for (var i = rules.length - 1; i > -1; i--) {
				if (sheet.removeRule) {
					sheet.removeRule(i);
				} else if (sheet.deleteRule) {
					sheet.deleteRule(i);
				}
			}
			ruleIndex = 0;
		}

		function addStyleRule(sheet, selector, rules) {
			try {
				if (sheet.insertRule) {
					sheet.insertRule(selector + "{" + rules + "}", ruleIndex)
				} else if (sheet.addRule) {
					sheet.addRule(selector, rules, ruleIndex);
				}
				ruleIndex++;
			}
			catch (e) {
				console.log(e);
			}
		}

		function parseStyleSheet(data) {
			// Remove <style> tags
			data = data.replace("<style>", "").replace("</style>", "");

			// result = array of { selector, rules }
			var result = [];
			var parser = /([^{]+)\s*\{\s*([^}|\n]+)\s*}/g;
			var match = null;

			while ((match = parser.exec(data)) != null) {
				if (match.index === parser.lastIndex) {
					parser.lastIndex++;
				}

				result.push({
					selector: match[1],
					rules: match[2]
				});
			}

			return result;
		}

		var ruleIndex;
		var updateStyles = debounce(function () {
			Cognito.serviceRequest({
				method: "POST",
				endpoint: "forms/admin/" + Cognito.Forms.model.formId + "/render-theme",
				data: Cognito.serialize(Cognito.Forms.model.theme),
				success: function (data) {
					Cognito.Forms.formController.updateTheme(data, Cognito.Forms.model.theme);
				}
			});
		}, 50);

		Cognito.Forms.updateStyles = updateStyles;

		var handleThemePropertyChanged = function () {
			Cognito.Forms.model.theme.set_hasChanges(true);
			updateStyles();
		}

		Cognito.Forms.initTheme = function () {
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme, function (sender, args) {
				if (args.get_propertyName() !== "hasChanges")
					handleThemePropertyChanged();
			});

			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Label(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Text(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Title(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Heading(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Link(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_Button(), handleThemePropertyChanged);
			Sys.Observer.addPropertyChanged(Cognito.Forms.model.theme.get_PlaceholderText(), handleThemePropertyChanged);
			initSlider();
		};

		Cognito.Forms.initPublish = function () {
			Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);

			// Hiding the publisher content until the publisher is initialized
			$("#c-forms-publish").show();

			// Construct the theme on the client if one does not exist. A theme would only exist if the user chooses to have a customized theme.

			var publicKey = Cognito.Forms.model.publishConfig.publicKey;
			var formId = Cognito.Forms.model.formId;

			ExoWeb.Observer.setValue(Cognito.Forms.model, "publishSettings", new Cognito.PublishSettings({
				formId: formId,
				formUrl: Cognito.Forms.model.publishConfig.formsBaseUrl + "/" + Cognito.Forms.model.formUrlName,
				publicKey: publicKey,
				seamlessCode: "<script src=\"" + Cognito.config.baseUrl + "f/seamless.js\" data-key=\"" + publicKey + "\" data-form=\"" + formId + "\"></script>",
				framedCode: "<iframe src=\"" + Cognito.config.baseUrl + "f/" + publicKey + "/" + formId + "\" allow=\"payment\" style=\"border:0;width:100%;\" height=\"0\"></iframe>\n<script src=\"" + Cognito.config.baseUrl + "f/iframe.js\"></script>",
				ampedCode: "<!-- Make sure you include the 'amp-iframe' extension JavaScript in the <head> -->\n<amp-iframe src=\"" + Cognito.config.baseUrl + "f/" + publicKey + "/" + formId + "\" layout=\"responsive\" resizable frameborder=\"0\" scrolling=\"yes\" height=\"200\" width=\"800\" sandbox=\"allow-scripts allow-same-origin allow-popups\"><div overflow></div><div placeholder></div></amp-iframe>",
				embedMode: "seamlessCode",
			}));

			Cognito.timers.activePublishSettings = setTimeout(function () {
				ExoWeb.Observer.setValue(Cognito.Forms.model, "activePublishSettings", Cognito.Forms.model.publishSettings);
			});

			var theme = Cognito.Forms.model.theme;

			$('body').attr('data-field-style', theme._Style.toLowerCase());

			$('.c-typeface-dropdown').addClass('wide');

			$(document).on('change', '.max-width-slider-number', function () {
				var width = $(this).val();
				changeWidth(width);
				$('.max-width-slider')[0].noUiSlider.set([width, null]);
			});

			$(document).on('change', '.embedded-form-margin-slider-number', function () {
				var margin = $(this).val();
				$('.embedded-form-margin-slider')[0].noUiSlider.set([margin, null]);
			});

			$("#c-forms-publish").delegate(".tab", "click", function () {
				Cognito.navigate(function () {
					var val = $(this).attr("data-target");

					ExoWeb.Observer.setValue(Cognito.Forms.model, "activePublishSettings", Cognito.Forms.model.publishSettings);

					$(".embed-type .c-tab-active").removeClass("c-tab-active");
					$(".embed-type .c-tab[data-value='" + Cognito.Forms.model.activePublishSettings.get_embedMode() + "']").addClass("c-tab-active");

					$("#c-forms-publish-content").children().hide();

					$("#c-forms-publish-styleform").children().hide();

					if (val === "c-forms-publish-themeSettings-theme") {
						$("#c-forms-publish-themeSettings-theme").show();
						Cognito.Messaging.trigger("fetchThemesData");
					}
					else {
						$("#c-forms-publish-themeSettings-theme").hide();
					}

					$("#" + val).show();
					$(".tab").removeClass("active");
					$(this).addClass("active");
				}.bind(this));
			});

			$(document).on('change', '.js-field-style-select', function () {
				$('body').attr('data-field-style', $(this).val().toLowerCase());
			});

			computeColorLibrary();
		};

		function debounce(func, wait, immediate) {
			var timeout;
			var timeoutId = 't' + Date.now();
			return function () {
				var context = this, args = arguments;
				Cognito.timers[timeoutId] = clearTimeout(timeout);
				Cognito.timers[timeoutId] = timeout = setTimeout(function () {
					Cognito.timers[timeoutId] = timeout = null;
					if (!immediate) func.apply(context, args);
				}, wait);
				if (immediate && !timeout) func.apply(context, args);
			};
		}

		function changeWidth(width) {
			var evt = document.createEvent('UIEvents');
			evt.initUIEvent('resize', true, false, window, 0);
			window.dispatchEvent(evt);

			Cognito.Forms.model.theme.set_formMaxWidth(parseInt(width));
		}

		function initSlider() {
			window.setTimeout(function () {
				var maxFormWidthSlider = $(".max-width-slider")[0];
				var maxFormWidthSliderValue = $(".max-width-slider-number")[0];
				noUiSlider.create(maxFormWidthSlider, {
					start: maxFormWidthSliderValue.value,
					connect: "lower",
					step: 1,
					range: {
						'min': parseInt(maxFormWidthSliderValue.min),
						'max': parseInt(maxFormWidthSliderValue.max)
					}
				});

				maxFormWidthSlider.noUiSlider.on('update', function (values, handle) {
					var width = Math.round(values[handle]);
					var widthStyleEl;

					if (document.getElementById('form-max-width-setting')) {
						widthStyleEl = document.getElementById('form-max-width-setting');
					} else {
						widthStyleEl = document.createElement('style');
						widthStyleEl.id = 'form-max-width-setting';
						document.querySelector('body').appendChild(widthStyleEl);
					}
					widthStyleEl.innerText = '#c-admin .cog-form { --form__width: ' + width + 'px; }';
					changeWidth(width);
				});

				var embeddedMarginSlider = $(".embedded-form-margin-slider")[0];
				var embeddedMarginValue = $(".embedded-form-margin-slider-number")[0];
				noUiSlider.create(embeddedMarginSlider, {
					start: embeddedMarginValue.value,
					connect: "lower",
					step: 1,
					range: {
						'min': parseInt(embeddedMarginValue.min),
						'max': parseInt(embeddedMarginValue.max)
					}
				});

				embeddedMarginSlider.noUiSlider.on('update', function (values, handle) {
					var margin = Math.round(values[handle]);
					Cognito.Forms.model.theme.set_EmbeddedFormMargin(margin);
				});
			}, 1);
		}

		function applyTheme(onSuccess, onFailure, navigating) {
			if (Cognito.Forms.model.themeId !== CUSTOM_STYLES_THEME_ID) {
				Cognito.serviceRequest({
					endpoint: "svc/themes/" + Cognito.Forms.model.themeId + "/apply",
					method: "POST",
					data: { formId: Cognito.Forms.model.publishSettings.get_formId() },
					success: function () {
						Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);
						Cognito.Forms.model.theme.set_hasChanges(false);

						$('.c-forms-publish-save').trigger("progress-finished", "successful");

						if (onSuccess)
							onSuccess();
					},
					error: function (data) {
						$('.c-forms-publish-save').trigger("progress-finished", "failed");
						console.error('failed to update form setting', data);

						if (onFailure)
							onFailure();
					}
				});

			}
			// Use Default Theme
			else if (Cognito.Forms.model.hideStyleTabs && Cognito.Forms.model.themeId !== CUSTOM_STYLES_THEME_ID) {
				Cognito.serviceRequest({
					endpoint: "svc/themes/1/apply",
					method: "POST",
					data: { formId: Cognito.Forms.model.publishSettings.get_formId() },
					success: function (data) {
						Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);
						Cognito.Forms.model.theme.set_hasChanges(false);
						$('.c-forms-publish-save').trigger("progress-finished", "successful");

						if (onSuccess)
							onSuccess();
					},
					error: function (data) {
						$('.c-forms-publish-save').trigger("progress-finished", "failed");
						console.error('failed to update form setting', data);

						if (onFailure)
							onFailure();
					}
				});
			}
			// Update Custom Theme
			else {
				Cognito.Forms.updateTheme(Cognito.Forms.model.formId,
					Cognito.Forms.model.theme,
					function (themeData) {
						Cognito.Forms.model.persistedThemeData = themeData;

						Cognito.Forms.model.theme.set_hasChanges(false);
						if (!navigating) {
							computeColorLibrary();
						}

						if (onSuccess)
							onSuccess();
					},
					function () {
						$('.c-forms-publish-save').trigger("progress-finished", "failed");

						if (onFailure)
							onFailure();
					});
			}
		}

		Cognito.Forms.applyTheme = applyTheme;

		Cognito.Forms.updateThemeSettings = function (onSuccess, onFailure) {
			if (Cognito.Forms.model.themeId !== CUSTOM_STYLES_THEME_ID) {
				Cognito.serviceRequest({
					endpoint: "svc/themes/" + Cognito.Forms.model.themeId,
					method: "POST",
					data: {
						currentFormId: Cognito.Forms.model.publishSettings.get_formId(),
						themeName: Cognito.Forms.model.theme.Name,
						themeJson: JSON.stringify(Cognito.serialize(Cognito.Forms.model.theme)),
					},
					success: function (response) {
						applyThemeStyles(Cognito.serialize(Cognito.Forms.model.theme));
						Cognito.Messaging.trigger("updateThemePreview", { origin: Cognito.config.baseUrl, data: response });

						if (onSuccess)
							onSuccess();
					},
					error: function (data) {
						$('.c-forms-publish-save').trigger("progress-finished", "failed");
						console.error('failed to update theme setting', data);

						if (onFailure)
							onFailure();
					}
				});

			}
		}

		Cognito.Forms.setEnforceDefaultTheme = function (val, theme, resetUnsavedChanges) {
			if (val)
				Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);
			else
				computeColorLibrary();

			ExoWeb.Observer.setValue(Cognito.Forms.model, "hideStyleTabs", val);

			if (val) {
				applyThemeStyles(theme)
			}
			else {
				applyThemeStyles(Cognito.Forms.model.persistedThemeData)
			}

			if (resetUnsavedChanges)
				Cognito.Forms.model.theme.set_hasChanges(false);
			else
				Cognito.Forms.model.theme.set_hasChanges(true);
		}

		//theme, enableEditTheme, discardUnsavedChanges, triggerUnsavedChanges
		Cognito.Forms.changeTheme = function (options) {
			const theme = options.theme;
			const enableEditTheme = options.enableEditTheme;
			const discardUnsavedChanges = options.discardUnsavedChanges;
			const triggerUnsavedChanges = options.triggerUnsavedChanges;
			const deletingTheme = options.deletingTheme;

			const targetThemeId = theme ? theme.Id : CUSTOM_STYLES_THEME_ID;
			const previousThemeId = Cognito.Forms.model.themeId;
			const switchingToCustomStyles = targetThemeId === CUSTOM_STYLES_THEME_ID;
			const switchingFromCustomStyles = previousThemeId === CUSTOM_STYLES_THEME_ID;
			const hadChanges = Cognito.Forms.model.theme.get_hasChanges();

			if (theme === undefined)
				applyThemeStyles(Cognito.Forms.model.persistedThemeData);

			if ($('body').attr('data-field-style') !== "chameleon")
				$('body').attr('data-field-style', Cognito.Forms.model.theme.get_Style().toLowerCase());
			if (switchingFromCustomStyles) {
				Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);

				if (!enableEditTheme)
					Cognito.Forms.disableEditTheme()
			}

			if (switchingToCustomStyles)
				applyThemeStyles(Cognito.Forms.model.persistedThemeData);
			else
				applyThemeStyles(theme.Settings);

			ExoWeb.Observer.setValue(Cognito.Forms.model, "themeId", targetThemeId);
			if (!deletingTheme) {
				if (enableEditTheme) {
					Cognito.Forms.enableEditTheme(switchingToCustomStyles);

					if (switchingToCustomStyles || triggerUnsavedChanges)
						Cognito.Forms.model.theme.set_hasChanges(true);
					else if (!hadChanges)
						Cognito.Forms.model.theme.set_hasChanges(false);
				}
				else {
					Cognito.Forms.disableEditTheme();

					if (discardUnsavedChanges)
						Cognito.Forms.model.theme.set_hasChanges(false);
					else
						Cognito.Forms.model.theme.set_hasChanges(true);
				}
			}
			else {
				// When deleting a theme, update persistedThemeData to the replacement theme
				Cognito.Forms.model.persistedThemeData = Cognito.serialize(Cognito.Forms.model.theme);

				if (hadChanges)
					Cognito.Forms.model.theme.set_hasChanges(true);
				else
					Cognito.Forms.model.theme.set_hasChanges(false);
			}
		}

		Cognito.Forms.shouldChangeTheme = function (originalTheme) {
			if (!Cognito.Forms.model.hideStyleTabs && Cognito.Forms.model.theme.get_hasChanges() && Cognito.Forms.model.publishConfig.canUpdateDefaultTheme) {
				return new Promise(function (resolve, reject) {
					if (Cognito.Forms.model.themeId === CUSTOM_STYLES_THEME_ID) {
						resolve();
					}
					else {

						Cognito.navigate(function (changesSaved) {

							// If the changes were discarded, reset Cognito.Forms.model.theme
							if (!changesSaved) {
								if (originalTheme.Id === CUSTOM_STYLES_THEME_ID)
									applyThemeStyles(Cognito.Forms.model.persistedThemeData);
								else
									applyThemeStyles(originalTheme.Settings);
							}

							Cognito.Forms.model.theme.set_hasChanges(false);
							resolve();
						});
					}
				});
			}

			return Promise.resolve();
		}

		Cognito.Forms.enableEditTheme = function (switchingToCustomStyles) {
			if (switchingToCustomStyles)
				Cognito.Messaging.trigger("toggleSaveButtonIsEditingTheme", { origin: Cognito.config.baseUrl, data: false });
			else
				Cognito.Messaging.trigger("toggleSaveButtonIsEditingTheme", { origin: Cognito.config.baseUrl, data: true });

			$('body').attr('data-field-style', Cognito.Forms.model.theme.get_Style().toLowerCase());
			ExoWeb.Observer.setValue(Cognito.Forms.model, "hideStyleTabs", false);
			document.querySelector('.tab[data-target="c-forms-publish-themeSettings-header"]').click();
		}

		Cognito.Forms.disableEditTheme = function () {
			Cognito.Messaging.trigger("toggleSaveButtonIsEditingTheme", { origin: Cognito.config.baseUrl, data: false });
			ExoWeb.Observer.setValue(Cognito.Forms.model, "hideStyleTabs", true);
		}

		Cognito.Forms.handleSaveButtonClicked = function () {
			if (Cognito.Forms.model.themeId === CUSTOM_STYLES_THEME_ID) {
				applyTheme(function () {
					Cognito.Messaging.trigger("saveCompleted", { origin: Cognito.config.baseUrl, data: true });
				}, function () {
					Cognito.Messaging.trigger("saveCompleted", { origin: Cognito.config.baseUrl, data: false });
				});
			}
			else {
				Cognito.Forms.updateThemeSettings(function () {
					applyTheme(function () {
						Cognito.Messaging.trigger("saveCompleted", { origin: Cognito.config.baseUrl, data: true });
					}, function () {
						Cognito.Messaging.trigger("saveCompleted", { origin: Cognito.config.baseUrl, data: false });
					});
				}, function () {
					Cognito.Messaging.trigger("saveCompleted", { origin: Cognito.config.baseUrl, data: false });
				});
			}
		}

		function setFormMaxWidth(val) {
			const maxWidthSlider = $('.max-width-slider')[0].noUiSlider;
			if (!maxWidthSlider)
				return;

			if (val < 200)
				maxWidthSlider.set([Cognito.Forms.model.defaultFormMaxWidth, null]);
			else
				maxWidthSlider.set([val, null]);
		}

		Cognito.Forms.serializeTheme = function () {
			return Cognito.serialize(Cognito.Forms.model.theme);
		}

		// Update the form preview styles
		function applyThemeStyles(theme) {
			Cognito.deserialize(Cognito.Forms.ThemeSettings, theme, Cognito.Forms.model.theme);
			setFormMaxWidth(theme.FormMaxWidth);
		}

		$(document)

			// Sets the font of the picker to the selected font
			.on("change", ".c-font-picker", function font$change() {
				var font = $(this).val();
				font = font.indexOf('|') > 0 ? font.substr(0, font.indexOf('|')) : font;
				$(this).css("font-family", font);
				$(this).parent().parent().find(".c-font-size-picker").css("font-family", font);
			})

			// Reset theme-an-ator
			.on("click", "#resetLink", function resetLink$click() {
				document.location.reload();
			})

			// Save theme
			.on("click", ".c-forms-publish-save", function (event) {
				Cognito.Forms.updateThemeSettings();
				applyTheme(function () {
					$('.c-forms-publish-save').trigger("progress-finished", "successful")
				});
			})

			// Copy Embed Code/Public Link
			.on("click", "#c-forms-publish-public-link, #c-forms-publish-embed-code", function (event) {
				this.focus();
				this.select();
				try {
					if (document.execCommand('copy'))
						$(this).parent().siblings(".c-helptext").css({ "opacity": "1" }).animate({ "opacity": "0" }, 2000);
				}
				catch (err) {
				}
			})

			.on("click", ".embed-type a", function (event) {
				var mode = $(this).attr("data-value");

				Cognito.Forms.model.publishSettings.set_embedMode(mode);

				$(this).parent().children("a").removeClass("c-tab-active");
				$(this).addClass("c-tab-active");
				event.stopPropagation();
				event.preventDefault();
				return false;
			})

			.on('click', '#c-forms-verify-link', function () {
				$(this).addClass('c-status-working').prop("disabled", false);
				Cognito.serviceRequest({
					endpoint: "svc/auth/verify/resend-verify-email",
					method: "POST",
					success: function (data) {
						$('#c-forms-verify-link').removeClass('c-status-working');
						$('#c-forms-verify-link').addClass('c-status-successful');
						setTimeout(function () {
							$('#c-forms-verify-link').removeClass('c-status-successful');
						}, 2000);
					},
					error: function (data) {
						$('#c-forms-verify-link').removeClass('c-status-working');
						$('#c-forms-verify-link').addClass('c-status-failed');
						setTimeout(function () {
							$('#c-forms-verify-link').removeClass('c-status-failed');
						}, 2000);
					}
				});
			});
	});

	Cognito.ready("Publish Init", ["publish", "Views.Admin.publish.htm", "admin-component-library"], function ($) {
		// Handle navigation events when there are unsaved changes
		Cognito.onNavigate({
			title: "Unsaved Changes",
			text: "You currently have unsaved changes!",
			open: function () {
				if ((event && event.srcElement && event.srcElement.parentElement && event.srcElement.parentElement.dataset && event.srcElement.parentElement.dataset.target
					&& ["c-forms-publish-embed", "c-forms-publish-themeSettings-header", "c-forms-publish-themeSettings-form", "c-forms-publish-themeSettings-page"].includes(event.srcElement.parentElement.dataset.target))
					|| event && event.currentTarget && event.currentTarget.id && event.currentTarget.id == "c-forms-publish") {
					return false;
				}
				return Cognito.Forms.model.theme.get_hasChanges() && !document.cookie.includes('cognito.view-as-user.' + Cognito.config.oid);
			},
			buttons: [
				{
					label: "Discard Changes",
					isCancel: true,
					click: function () {
						this.continue(false);
					}
				},
				{
					label: "Save Changes",
					click: function () {
						Cognito.Forms.updateThemeSettings();
						var that = this;
						Cognito.Forms.applyTheme(function () {
							that.continue(true);
						}, null, true);
						this.close();
					}
				}
			]
		});

		Sys.Application.activateElement(document.documentElement);

		Cognito.Forms.initPublish();

		// Grab height of the form
		Cognito.Forms.model.publishSettings.set_formHeight($("#c-forms").height());

		// Init theme after the templates have been rendered so that the templates are not themed
		Cognito.timers.initTheme = setTimeout(function () { Cognito.Forms.initTheme(); }, 1);
	});

	Cognito.ready("form-mount", ["Publish Init", "admin-form-api"], function ($) {
		Cognito.Forms.formController = {
			mounted: false,
			form: null,
			api: AdminForm,
			updateTheme: function (data, themeSettings) {
				if (!Cognito.Forms.formController.mounted)
					Cognito.Forms.formController.mount();
				var logo = themeSettings.get_Logo();
				Cognito.Forms.formController.form.updateThemeStyles(
					{
						css: data.Css,
						links: data.Links
					},
					{
						logo: logo ? logo.get_Url() : null,
						headerLayout: themeSettings.get_HeaderLayout().get_Name(),
						headerAlignment: themeSettings.get_HeaderAlignment().get_Name(),
						logoAlt: themeSettings.get_LogoAlternativeText(),
						isChameleon: themeSettings._Style === 'Chameleon'
					},
					Cognito.serialize(themeSettings)
				);
			},
			mount: function () {
				if (Cognito.Forms.formController.mounted)
					return;

				Cognito.Forms.formController.mounted = true;
				var settings = Cognito.Forms.model.publishSettings;
				Cognito.Forms.formController.form = Cognito.Forms.formController.api.mount(settings.get_formId(), '#form', 'publish');
				Cognito.Forms.formController.form.on("ready", function () {
					var formContainer = document.querySelector(".cog-form__container");
					Cognito.Forms.model.publishSettings.set_formHeight(formContainer.clientHeight);

					var brandingEl = document.querySelector('.cog-branding');
					var hasPaidPlan = Cognito.config.hasPaidPlan;

					if (brandingEl && !hasPaidPlan) {
						var removeButton = document.createElement('button');
						removeButton.classList.add('cog-branding__remove', 'text-button');
						removeButton.title = 'Remove Cognito Forms branding';
						removeButton.innerHTML = '<i class="icon-trash"></i> <span class="cog-branding__remove-text">Remove</span>';

						brandingEl.append(removeButton);
						removeButton.addEventListener('click', function () {
							VueComponents.UpsellDialog.open({ feature: 'branding', isOrgOwner: true, orgCode: Cognito.config.organizationCode });
						});
					}
				});
			}
		}

		Cognito.Forms.formController.mount();
	});
})(typeof exports === 'undefined');
